import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { formName } from '../Constants/constants';
import {
  editForm,
  confirmPayment,
  startLoading,
  PAYMENT_INFO_FORM,
} from '../Actions/actions';
import PaymentInformation from '../Components/PaymentInformation/PaymentInformation';

const formValues = formValueSelector(formName);

const fieldSelect = (state, fieldName) => {
  if (
    state.formPage.paymentInfo.payeeSame &&
    state.formPage.insuranceContact.contactSame
  ) {
    return fieldName
      ? formValues(state, `insured${fieldName}`)
      : state.formPage.insured.insuredRenter;
  }
  if (state.formPage.paymentInfo.payeeSame) {
    return fieldName
      ? formValues(state, `contact${fieldName}`)
      : state.formPage.insuranceContact.contactRenter;
  }
  return fieldName
    ? formValues(state, `payee${fieldName}`)
    : state.formPage.paymentInfo.payeeRenter;
};

const mapStateToProps = (state) => ({
  enabled: state.formPage.paymentInfo.enabled,
  confirmed: state.formPage.paymentInfo.confirmed,
  valid: state.formPage.paymentInfo.valid,
  isLoading: state.formPage.paymentInfo.isLoading,
  payeeCardNum: formValues(state, 'payeeCardNum') || '',
  payeeCardName: formValues(state, 'payeeCardName') || '',
  payeeCardExp: formValues(state, 'payeeCardExp') || '',

  payeeSame: state.formPage.paymentInfo.payeeSame,
  errorMessage: state.formPage.paymentInfo.errorMessage,
  contactSame: state.formPage.insuranceContact.contactSame,

  payeeRenter: fieldSelect(state),
  payeeFirstName: state.formPage.paymentInfo.payeeSame
    ? formValues(state, 'contactFirstName')
    : formValues(state, 'payeeFirstName'),
  payeeLastName: state.formPage.paymentInfo.payeeSame
    ? formValues(state, 'contactLastName')
    : formValues(state, 'payeeLastName'),
  payeeCompany: fieldSelect(state, 'Company'),
  payeeAddress: fieldSelect(state, 'Address'),
  payeeCity: fieldSelect(state, 'City'),
  payeeState: fieldSelect(state, 'State'),
  payeeZip: fieldSelect(state, 'Zip'),
  payeeCountry: fieldSelect(state, 'Country'),
  usStates: state.formPage.usStates,
});

const handleConfirmClick = (dispatch) => {
  dispatch(startLoading(PAYMENT_INFO_FORM));
  dispatch(confirmPayment());
};

const mapDispatchToProps = (dispatch) => ({
  edit: () => dispatch(editForm(PAYMENT_INFO_FORM)),
  confirm: () => handleConfirmClick(dispatch),
});

const PaymentInformationContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentInformation);

export default PaymentInformationContainer;
